/**
 * MST models for selection wizards embedded in `aiConfiguration.wizards`.
 * Snapshots align with `SelectionWizardConfig` / `WizardStep` in `@mcn-platform/converse-lib`.
 */
import { types } from 'mobx-state-tree';
export const FormattedTextModel = types.model('FormattedText', {
    type: types.literal('FormattedText'),
    html: types.string,
});
const WizardLabel = types.union(types.string, FormattedTextModel);
export const WizardOptionModel = types.model('WizardOption', {
    value: types.string,
    label: types.string,
    description: types.optional(types.string, ''),
    imageAssetKey: types.optional(types.string, ''),
    imageUrl: types.optional(types.string, ''),
});
/** Keyed by gender option `value` (dynamic men/women/kids/…). */
const WizardSizeOptionModel = types.map(types.array(types.string));
const WizardWidthBandsModel = types.map(types.array(WizardOptionModel));
export const WizardQuestionModel = types.model('WizardQuestion', {
    id: types.string,
    label: WizardLabel,
    selectType: types.optional(types.enumeration(['single', 'multiple']), 'single'),
    options: types.array(WizardOptionModel),
    imageAssetKey: types.optional(types.string, ''),
    imageUrl: types.optional(types.string, ''),
});
export const WizardShoeSizeQuestionModel = types.model('WizardShoeSizeQuestion', {
    id: types.string,
    label: WizardLabel,
    type: types.literal('gender_size_width'),
    genderOptions: types.array(WizardOptionModel),
    sizeOptions: WizardSizeOptionModel,
    widthOptions: WizardWidthBandsModel,
    imageAssetKey: types.optional(types.string, ''),
    imageUrl: types.optional(types.string, ''),
});
/** Shoe-size step vs standard question; discriminated by `type === 'gender_size_width'`. */
export const WizardStepModel = types.union(WizardShoeSizeQuestionModel, WizardQuestionModel);
export const SelectionWizardModel = types.model('SelectionWizard', {
    id: types.string,
    name: types.optional(types.string, ''),
    steps: types.array(WizardStepModel),
});
//# sourceMappingURL=SelectionWizardModel.js.map